import useAuth from 'src/hooks/api/useAuth';
import { useCallback, useEffect, useState } from 'react';

type DealTypeReturnType = Array<{
  value: number;
  label: string;
}>;

export default () => {
  const { fetch: authFetch } = useAuth();
  const [dealTypes, setDealTypes] = useState<DealTypeReturnType>([]);

  const getDealTypes = useCallback(async () => {
    let queryURL = '/api/dealType/';
    let graphQL = '{ dealTypes{id, name} }';
    queryURL += graphQL;

    try {
      const resp = await authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      });

      const data = await resp.json();

      return data.data.dealTypes.map((p) => ({
        value: p.id,
        label: p.name,
      }));
    } catch (error) {
      console.log('erreur fetch search async:\n%s', error);
      return [];
    }
  }, []);

  useEffect(() => {
    getDealTypes().then(setDealTypes);
  }, []);

  return dealTypes;
};
